// AnimatedBackground.js - Without rotating straight lines
import React from 'react';
import './AnimatedBackground.css';

const AnimatedBackground = () => {
  return (
    <div className="animated-background">
      {/* Fully curved waves */}
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        version="1.1" 
        viewBox="0 0 1440 800"
        preserveAspectRatio="none"
        className="bg-waves"
      >
        <defs>
          <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="rgba(79, 70, 229, 0.2)" />
            <stop offset="50%" stopColor="rgba(59, 130, 246, 0.15)" />
            <stop offset="100%" stopColor="rgba(37, 99, 235, 0.1)" />
          </linearGradient>
          <linearGradient id="gradient2" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="rgba(59, 130, 246, 0.15)" />
            <stop offset="50%" stopColor="rgba(96, 165, 250, 0.1)" />
            <stop offset="100%" stopColor="rgba(147, 197, 253, 0.05)" />
          </linearGradient>
          <linearGradient id="gradient3" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="rgba(16, 185, 129, 0.15)" />
            <stop offset="50%" stopColor="rgba(110, 231, 183, 0.1)" />
            <stop offset="100%" stopColor="rgba(167, 243, 208, 0.05)" />
          </linearGradient>
        </defs>

        {/* Wave 1 - fully curved on top and bottom */}
        <path 
          d="M0,100 C150,150 300,50 450,100 S600,150 750,100 S900,50 1050,100 S1200,150 1350,100 L1440,100 L1440,500 C1290,450 1140,550 990,500 S840,450 690,500 S540,550 390,500 S240,450 90,500 L0,500 Z"
          fill="url(#gradient1)"
          className="wave1"
        />
        
        {/* Wave 2 - different curve pattern */}
        <path 
          d="M0,150 C120,100 240,200 360,150 S480,100 600,150 S720,200 840,150 S960,100 1080,150 S1200,200 1320,150 L1440,150 L1440,550 C1320,600 1200,500 1080,550 S960,600 840,550 S720,500 600,550 S480,600 360,550 S240,500 120,550 L0,550 Z"
          fill="url(#gradient2)"
          className="wave2"
        />
        
        {/* Wave 3 - another curve pattern */}
        <path 
          d="M0,200 C160,250 320,150 480,200 S640,250 800,200 S960,150 1120,200 S1280,250 1440,200 L1440,600 C1280,550 1120,650 960,600 S800,550 640,600 S480,650 320,600 S160,550 0,600 Z"
          fill="url(#gradient3)"
          className="wave3"
        />

        {/* Extra wavy background element */}
        <path 
          d="M0,300 C100,320 200,280 300,300 S400,320 500,300 S600,280 700,300 S800,320 900,300 S1000,280 1100,300 S1200,320 1300,300 L1440,300 L1440,650 C1340,630 1240,670 1140,650 S1040,630 940,650 S840,670 740,650 S640,630 540,650 S440,670 340,650 S240,630 140,650 L0,650 Z"
          fill="rgba(59, 130, 246, 0.08)"
          className="wave4"
        />
      </svg>
      
      {/* Floating particles with random movement */}
      {/* <div className="particles">
        {Array.from({ length: 20 }).map((_, i) => (
          <div 
            key={i} 
            className="particle"
            style={{
              top: `${10 + Math.random() * 80}%`,
              left: `${10 + Math.random() * 80}%`,
              width: `${6 + Math.random() * 6}px`,
              height: `${6 + Math.random() * 6}px`,
              animationDuration: `${15 + Math.random() * 15}s`,
              animationDelay: `${Math.random() * 5}s`
            }}
          />
        ))}
      </div> */}
    </div>
  );
};

export default AnimatedBackground;